import { getRefreshToken } from '@/shared/auth/jwt-storage';
import { useRefreshAccessToken } from '@/shared/hooks/use-refresh-token';
/** Inside authenticated shell only — skips when no refresh token is present yet. */
export function useAuthenticatedRefresh() {
    const refreshTokenReady = typeof window !== 'undefined' && Boolean(getRefreshToken());
    useRefreshAccessToken(refreshTokenReady);
}
